<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>call_made</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>&nbsp;Alta de Ventas de Cartera</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1" color="green"
              >Selección de Créditos</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2" color="yellow"
              >Datos de la Venta</v-stepper-step
            >
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-container fluid>
                <v-row>
                  <v-col cols="4">
                    <v-autocomplete
                      v-model="filtro.productoId"
                      :items="productos"
                      item-text="descripcion"
                      item-value="id"
                      label="Del producto:"
                      placeholder="Seleccione uno"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="4">
                    <v-autocomplete
                      v-model="filtro.canalVentaId"
                      :items="canalesVenta"
                      item-text="nombre"
                      item-value="id"
                      label="Originadas en:"
                      placeholder="Seleccione un Canal de Venta"
                      :menu-props="{ minWidth: '400' }"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="4">
                    <app-selector-periodos
                      v-on:update-periodo="filtro.periodo = $event"
                      :column="true"
                    ></app-selector-periodos>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="3">
                    <v-text-field
                      v-model="filtro.capitalDesde"
                      label="Capital Desde"
                      key="capitalDesde"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="3">
                    <v-text-field
                      v-model="filtro.capialHasta"
                      label="Capital Hasta"
                      key="capitalHasta"
                    ></v-text-field>
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="3">
                    <v-btn
                      color="success"
                      @click.stop="getItems(true)"
                      :disabled="loading"
                      >Buscar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>

              <v-card>
                <v-toolbar :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Resultados</v-toolbar-title
                  >
                </v-toolbar>

                <v-data-table
                  dense
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :rows-per-page="pagination.rowsPerPage"
                  :options.sync="pagination"
                  v-model="selectedCreditos"
                  :loading="loading"
                  :footer-props="footer"
                  :show-select="records.length > 0"
                >
                  <template v-slot:no-data>
                    <v-alert
                      v-if="!primeraBusquedaRealizada"
                      :value="true"
                      color="grey lighten-3"
                      icon="info"
                    >
                      Ingrese los filtros para realizar la búsqueda
                    </v-alert>
                    <v-alert v-else :value="true" color="grey" icon="warning">
                      No se encontraron registros con los filtros ingresados
                    </v-alert>
                  </template>

                  <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td>
                        <v-simple-checkbox
                          class="caption"
                          color="green"
                          :value="isSelected"
                          @input="select($event)"
                        ></v-simple-checkbox>
                      </td>

                      <td>
                        <app-acciones-comunes
                          :documento="item.cuil.toString().substring(2, 10)"
                          :solicitudId="item.id"
                          :ocultarAnalisisConsulta="true"
                          :ocultarAnalisisCredito="true"
                        >
                        </app-acciones-comunes>
                      </td>

                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.origen
                          }}
                        </tr>
                        <tr class="text-xs-left font-weight-light caption">
                          {{
                            item.producto
                          }}
                          /
                          {{
                            item.planNombre
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">{{ item.cuil }}</td>
                      <td class="text-xs-left caption">
                        {{ item.solicitante }}
                      </td>
                      <td class="text-xs-left caption">{{ item.numero }}</td>
                      <td class="text-xs-left caption">
                        {{
                          item.fechaIngreso
                            | dateParse('YYYY-MM-DD')
                            | dateFormat('DD-MM-YYYY')
                        }}
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.monto | currency }}
                      </td>

                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.cuotas
                          }}
                          de
                        </tr>
                        <tr>
                          {{
                            item.importeCuota | currency
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.cuotasAdeudadas }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.totalAdeudado | currency }}
                      </td>
                      <td class="text-xs-left caption">
                        <v-chip small :color="item.empresaColor" label dark>{{
                          item.empresaShort
                        }}</v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-container>
                <v-row align="center">
                  <v-chip color="green" dark small>
                    Créditos Seleccionados: {{ cantidadCreditos }}
                  </v-chip>
                  &nbsp;&nbsp;&nbsp;
                  <v-chip color="green" dark small>
                    Importe Total: {{ importeTotalVenta | currency }}
                  </v-chip>
                </v-row>

                <v-row align="center">
                  <v-col cols="3">
                    <v-text-field
                      v-model="model.nombre"
                      label="Nombre de la Venta"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete
                      v-model="model.inversorId"
                      :items="inversores"
                      item-text="nombre"
                      item-value="id"
                      label="Inversor"
                      placeholder="Seleccione uno"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete
                      v-model="model.tipoVentaCarteraId"
                      :items="tiposVentaCartera"
                      item-text="descripcion"
                      item-value="id"
                      label="Tipo Venta"
                      placeholder="Seleccione uno"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                    <v-text-field
                      v-model="model.tasaDescuento"
                      label="Tasa de Descuento"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-btn color="blue darken-1" dark @click.stop="step = 1"
                    ><v-icon left>arrow_back</v-icon>Volver a Selección</v-btn
                  >
                </v-row>

                <template v-if="$store.state.debugModeOn">
                  Debug Info:
                  <p></p>
                  {{ model }}
                  <p></p>
                </template>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark @click.stop="confirmar"
          >{{ step == 1 ? 'Comenzar Proceso de Venta' : 'Confirmar Venta' }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <template v-if="$store.state.debugModeOn">
      <!--   Debug Info: <p></p>
            {{listCargosAAplicar}}
            CreditoSeleccionado: {{creditoSeleccionadoId}}   -->
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { addDays, format } from 'date-fns';
import { Decimal } from 'decimal.js';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    step: 1,
    loading: false,
    headers: [
      // definición de columnas
      { text: 'Ver', value: 'accion', width: 80, sortable: false },
      { text: 'Origen', value: 'origen' },
      { text: 'Cuil', value: 'cuil' },
      { text: 'Nombre', value: 'solicitante' },
      { text: 'Número', value: 'numero' },
      { text: 'Fecha de Ingreso', value: 'fechaIngreso' },
      { text: 'Capital', value: 'capital', width: 130 },
      { text: 'Cuotas', value: 'cuotas', width: 130 },
      { text: 'Cuotas Adeudadas', value: 'cuotasAdeudadas' },
      { text: 'Monto Adeudado', value: 'totalAdeudado', width: 130 },

      { text: 'Empresa', value: 'empresa' },
    ],
    pagination: {
      // definición de paginación
      sortDesc: [true],
      sortBy: [''],
      page: 1,
      itemsPerPage: 5,
    },
    footer: {
      showFirstLastPage: true,
      itemsPerPageOptions: [5, 10, 20, 50],
    },
    totalItems: 0, // va afuera de pagination
    records: [], // registros
    selectedCreditos: [],
    productos: [],
    canalesVenta: [],
    inversores: [],
    tiposVentaCartera: [],
    filtro: {
      productoId: 0,
      canalVentaId: 0,
      periodo: {},
      montoDesde: 0,
      montoHasta: 0,
    },
    resetPagination: false,
    primeraBusquedaRealizada: false,
    model: { tasaDescuento: 0 },
  }),
  created() {
    this.loadProductos();
    this.loadCanalesVenta();
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    importeTotalVenta() {
      return this.selectedCreditos
        .map((x) => x.totalAdeudado)
        .reduce((a, b) => a + b, 0);
    },
    cantidadCreditos() {
      return this.selectedCreditos.length;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems();
      },
      deep: true,
    },
    step: async function() {
      if (this.step == 2) {
        this.loadInversores();
        this.loadTiposVentaCartera();
      }
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    async getItems(resetPagination) {
      if (this.filtro.periodo.desde === undefined) {
        this.alertWarning('Debe elegir un periodo para la búsqueda.');
        return;
      }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      let idCanalesVenta = filter.canalVentaId.toString();

      //Si se eligió TODOS ( y no tiene acceso a todos los canales) armo un string con todos los canales de venta habilitados para el usuario.
      if (filter.canalVentaId === 0 && !this.user.accesoTodosCanalesVenta) {
        for (var i = 1; i < this.canalesVenta.length; i++) {
          if (i === 1) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += ',' + this.canalesVenta[i].id;
        }
      } else {
        idCanalesVenta = '0';
      }

      try {
        var result = await http.get(
          'creditos/listcreditosparaventacartera?canalesVenta=' +
            idCanalesVenta +
            '&productoId=' +
            filter.productoId +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&montoDesde=' +
            filter.montoDesde +
            '&montoHasta=' +
            (filter.montoHasta == 0 ? 999999 : filter.montoHasta) +
            '&limit=' +
            this.pagination.itemsPerPage +
            '&page=' +
            this.pagination.page +
            '&sortby=' +
            this.pagination.sortBy +
            '&descending=' +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : 'false')
        );

        Vue.$log.debug(result);
        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
      this.primeraBusquedaRealizada = true;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get('productos/');

        this.productos = result.list;

        this.productos.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?usuarioId=' + this.user.id
        );

        this.canalesVenta = result.list;

        this.canalesVenta.unshift({ id: 0, nombre: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadInversores() {
      this.loading = true;
      try {
        var result = await http.get('inversores');

        this.inversores = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposVentaCartera() {
      this.loading = true;
      try {
        var result = await http.get('tiposventacartera');

        this.tiposVentaCartera = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    confirmar() {
      if (this.step == 1) {
        if (this.selectedCreditos.length == 0) {
          this.alertWarning(
            'Debe elegir algún crédito para continuar con el alta'
          );
          return;
        }

        if (
          confirm(
            '¿Desea confirmar la generación de una Venta de Cartera con los ' +
              this.selectedCreditos.length +
              ' créditos seleccionados?'
          )
        ) {
          this.step++;
        }
      } else if (this.step == 2) {
        if (this.validarAlta()) {
          this.generarVentaCartera();
        }
      }
    },
    validarAlta() {
      if (!this.selectedCreditos || this.selectedCreditos.length == 0) {
        this.alertWarning('Debe elegir los créditos en el paso anterior.');
        return false;
      }

      if (!this.model.nombre) {
        this.alertWarning('Debe ingresar un Nombre.');
        return false;
      }

      if (!this.model.inversorId) {
        this.alertWarning('Debe elegir un Inversor.');
        return false;
      }

      if (!this.model.tipoVentaCarteraId) {
        this.alertWarning('Debe elegir un Tipo de Venta.');
        return false;
      }

      // if(!this.model.tasaDescuento)
      // {
      //     this.alertWarning('Debe ingresar la Tasa de Descuento.');
      //     return false;
      // }

      return true;
    },
    async generarVentaCartera() {
      this.loading = true;

      this.model.empresaId = this.selectedCreditos[0].empresaId;
      this.model.listaCreditos = this.selectedCreditos;

      try {
        var result = await http.post(
          'ventasCartera',
          JSON.stringify({ ventaCartera: this.model })
        );

        this.alertSuccess('Se ha generado la Venta de Cartera.');
        this.model = {};
        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
  },
};
</script>
